<script setup lang="ts">
import GalleryImage from './components/GalleryImage.vue';
import GalleryThumbnails from './components/GalleryThumbnails.vue';
import {useStore} from './store';

const store = useStore();
</script>

<template>
    <div class="gallery">
        <GalleryImage />
        <GalleryThumbnails v-if="store.images.length > 1" />
    </div>
</template>
